//BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : Start
import { memo } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BzModal, BzModalHeader, BzModalBody, BzButton, BzModalFooter } from '../../components/';
import { useDispatch, useSelector } from 'react-redux';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { getBasketRecoData } from '../../redux/actions/recommendation';


const BasketFollowUpAlertModal = () => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const objModalData = useSelector(state => state?.modals?.modalData);
    const onHandleClose = () => {
        dispatch(handleModal([{ 'BASKET_RECO_FOLLOWUP_ALERT_MODAL': false }]));
    };

    const handleNo = () => {
        dispatch(handleModal([{ 'BASKET_RECO_FOLLOWUP_ALERT_MODAL': false }, true]));
    };
    const handleYes = () => {
        dispatch(getBasketRecoData(objModalData?.data?.cartData.sRecoGroup));
        setTimeout(() => {
            dispatch(handleModal([{ 'RECOMMENDATION_CART_MODAL': true }, {'BASKET_RECO_FOLLOWUP_ALERT_MODAL' : false}]));
            dispatch(handleModalData({ data: { cartData: objModalData?.data?.cartData } }));
        }, 200);
    };
    return (
        <>
            <BzModal size='sm' show={modals['BASKET_RECO_FOLLOWUP_ALERT_MODAL']} onHide={onHandleClose}>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-items-center'>
                                <div className='font-medium font-size4 color-text'>Follow up recommendation</div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-items-center'>
                                <div className='icon-16 icon-dark icon-close' onClick={onHandleClose}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        <Row className='g-0 mb-3'>
                            <Col className='d-flex justify-content-start'>
                                <div className='font-regular font-size3 color-text'>This is follow up recommendation,have you executed the original Order cart?</div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalBody>
                <BzModalFooter>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col className='d-flex justify-content-end'>
                                <BzButton className='btn btn-md btn-outline  me-2' onClick={handleYes}>Yes</BzButton>
                                <BzButton className='btn btn-md btn-primary ms-2' onClick={handleNo}>No</BzButton>
                            </Col>
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>

        </>
    );
};

export default memo(BasketFollowUpAlertModal);
//BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : End
